<!-- 譲渡前のダイアログ -->
<template>
  <div>
    <ItemDialog ref="DialogBookTransferAlert" imageType="alert">
      <template v-slot:content-area>
        <p class="text-justify">譲渡用URLが発行されるため、メールなどでチケットを譲渡したい相手に送ってください。<br /><br />相手が受け取り操作を完了するまではチケットは残り、受け取り操作が完了すると同時にあなたのチケットは使用できなくなります。<br /><br />なお、表示が切り替わるまでタイムラグが発生します。<br /><br />
        <span class="warning-transfer-tickets">チケットを譲渡する前に、必ず譲渡される方（受け取る方）のアカウント作成をお願いいたします。</span>
        </p>
      </template>
      <template v-slot:button-area>
        <ItemButton
          label="OK"
          actionType="btn-primary"
          @clicked="postTransferKey"
        />

        <ItemButton
          label="キャンセル"
          actionType="btn-cancel"
          @clicked="closeDialog"
        />
      </template>
    </ItemDialog>
    <!-- 譲渡前のダイアログ -->

    <!-- ローディングダイアログ -->
    <DialogLoading ref="DialogLoading" />
  </div>
</template>

<script>
import API from "@/API";
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import nativeHandlerService from "@/services/nativeHandler";
import DialogLoading from "@/views/Components/Organisms/Common/Dialog/DialogLoading";

import commonMethodsMixin from "@/mixins/Common/CommonMethodsMixin";

export default {
  name: "DialogBookTransferAlert",
  components: {
    DialogLoading: DialogLoading,
  },
  setup() {
    const store = useStore();

    const DialogLoading = ref(null);
    const DialogBookTransferAlert = ref(null);

    const book = store.getters["ticketing/book"];
    const bookGroup = store.getters["ticketing/bookGroup"];
    const masterBook = store.getters["ticketing/masterBook"];

    const openDialog = () => {
      DialogBookTransferAlert.value.open();
    };

    const closeDialog = () => {
      DialogBookTransferAlert.value.close();
    };

    // 譲渡キーを発行して、メール立ち上げのためにネイティブへ譲歩を受け渡す関数
    const postTransferKey = async () => {
      closeDialog();
      DialogLoading.value.openDialog();

      // 譲渡キーを発行
      const key = await API.postTransferKey(book.id);

      // 引き渡す情報をJSON化
      const info = {
        transfer_key: key.data.transfer_key,
        id: masterBook.id,
        name: commonMethodsMixin.methods.displayBookName(bookGroup, masterBook),
        book_group_id: bookGroup.id,
      };

      DialogLoading.value.closeDialog();
      nativeHandlerService.ncSetTransferTicket(info);
    };

    return {
      postTransferKey,
      DialogLoading,
      DialogBookTransferAlert,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-justify {
  text-align: justify;
}
.warning-transfer-tickets {
  color: #ff0000;
}
</style>